<template>
<div>
  <div class="h-100 w-100 track-item flex">
    <div @click="playTrack" class="pointer h-100 w-95">
      <div class="fl w-10 ma0 flex flex-row items-center justify-between ">
        <font-awesome-icon v-show="currentTrack != track || !isPlaying " @click.stop="playTrack" icon="play" size="1x" class="play-pause-icon pointer ml3 mr1 h-100 textColor"/>
        <font-awesome-icon v-show="currentTrack == track && isPlaying" @click.stop="setPlaying(false)" icon="pause" size="1x" class="play-pause-icon pointer ml3 mr1 h-100 textColor"/>
        <div class="image-container">
          <img class="track-image h-100 w-100" :src="picture">
        </div>
      </div>
      <p class="title fl w-30 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.title }}</p>
      <router-link :to="{ name:'artist-info', params:{ id:track.id_artist }}" append @click.native.stop class="textColor no-underline">
        <p v-if="profileTracks === false" class="artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.artist.name }}</p>
        <p v-if="profileTracks === true" class="artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.name }}</p>
      </router-link>
      <p v-if="profileTracks === false" class="genre fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.genre.name }}</p>
      <p v-if="profileTracks === true" class="genre fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor">{{ track.music_type }}</p>
      <p class="released fl w-15 h-100 pa1 pl3 ma0 center-content textColor">{{ this.trackTime }}</p>
    </div>
    <div class="w-5 h-100 ma0">
      <track-options-button :track="track" class="ma0 textColor"/>
    </div>
  </div>
  <track-card @play="playTrack" class="track-card w-100 textColor" :profileTracks="profileTracks" :track="track"/>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TrackImage from './TrackImage'
  import TrackData from './TrackData'
  import TrackCard from './TrackCard'
  import TrackOptionsButton from '@/components/tracks/TrackOptionsButton.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'

  export default {
    name: 'track-item-list',
    props: {
      track: {
        required: true
      },
      profileTracks: {
        default: false
      }
    },
    data () {
      return {
        trackTime: null
      }
    },
    components: {
      TrackImage,
      TrackData,
      TrackOptionsButton,
      FontAwesomeIcon,
      TrackCard
    },
    computed: {
      ...mapGetters('player', [
        'currentTrack',
        'isPlaying'
      ]),
      ...mapGetters('track', [
        'loading',
        'allTracks'
      ]),
      picture () {
        return consts.MEDIA_BASE_URL + this.track.picture
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'changeTrack'
      ]),
      playTrack () {
        if (this.currentTrack !== this.track) {
          this.$emit('play')
          this.changeTrack(this.track)
        } else {
          this.setPlaying(true)
        }
      },
      trackTimeToMin () {
        let seg = this.track.seconds
        let min = 0
        this.trackTime = 0
        for (let i = 0; i < 60; i++) {
          if (seg >= 60) {
            min++
            seg -= 60
          } else if (seg < 60) {
            if (seg <= 9) {
              this.trackTime = (`${min}:0${seg}`)
              return this.trackTime
            } else {
              this.trackTime = (`${min}:${seg}`)
              return this.trackTime
            }
          }
        }
      }
    },
    mounted () {
      this.trackTimeToMin()
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .center-content {
    line-height: normal;
  }

  .play-pause-icon {
    margin-left: 10px;
  }

  .track-card {
    display: none;
  }

  .image-container {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  @media (max-width: 768px) {
    .track-card {
      display: flex !important;
    }

    .track-item {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackItemList.vue